export default "__VITE_ASSET__DMkv1mFr__"